import React from 'react'

import { Col, Form } from '_zari/core'

const FlagTodasCuentasFormGroup = ({ checked, onChange }) => {
  return (
    <Form.Group>
      <Col md={4} />
      <Col md={8}>
        <Form.Checkbox
          id='checkbox-flagTodasCuentas'
          name='checkbox-flagTodasCuentas'
          label='Todas las cuentas'
          checked={checked}
          onChange={onChange}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagTodasCuentasFormGroup)
